import { Button } from 'common/Components/Button';
import InputPin from 'common/Components/form/InputPin';
import { ChevronLeftIcon } from 'common/Icons';
import { getCookies, handleProductType } from 'common/method/helper';
import { useLayoutEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useGetCaptch } from 'services/login';
import Captcha from 'common/Components/Captcha';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { toast } from 'react-toastify';
import { useMobileRequest, useTurntoggleMobileState } from 'services/twoFactor';
import { useRouter } from 'common/hooks/useRouter';
import { useRouterExternal } from 'common/hooks/useRouterExternal';
import { Trans, useTranslation } from 'react-i18next';
import { useReturnToApp } from 'common/hooks/returnToApp';

/** need 
Cookies.get("client_id") from cookies 
starredMessage , expireDate , state from state in react-router
*/

type formDataType = {
  captchaValue: string;
};

const FormTwoFactor = () => {
  //*global
  const [searchParams] = useSearchParams();
  const {
    autorizationSlice: { callBackUrl },
  } = useSelector((state: RootState) => state);

  const [otp, setOtp] = useState<string>('');

  const client_id = getCookies();

  const { pushExternal } = useRouterExternal();

  const { pushReturn } = useReturnToApp()


  const { t } = useTranslation();

  //*navigate
  const {
    navigate,
    history: {
      state: { starredMessage, expireDate, state },
    },
  } = useRouter();

  //*form
  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    setValue,
    getValues
  } = useForm<formDataType>({
    defaultValues: {
      captchaValue: '',
    },
    mode: 'onChange',
  });

  const onSubmit: SubmitHandler<formDataType> = (data) => {
    const otpRes = otp.replaceAll(' ', '').replaceAll('_', '');
    if (!captcha?.key) {
      refetchCaptchaMethod();
      return;
    } else if (!client_id) {
      navigate.pushLogin();
      return;
    } else if (otpRes.length !== 6) {
      toast.warning(t('Errors.OtpIsNotValid'));
      resetField('captchaValue');
      return;
    }

    const res = {
      otp: otpRes,
      captchaValue: data.captchaValue,
      captchaKey: captcha.key,
      productType: handleProductType(searchParams),
      token: client_id,
      state: state,
    };

    mutateTurnToggle(res);
  };

  //*useMobileRequest
  const { refetch: refechMobileRequest } = useMobileRequest({
    onSuccess: (data) => {
      if (data.succeeded) {
        const {
          result: { expireDate, starredMessage, state },
        } = data;
        navigate.pushHere({
          state: { starredMessage, expireDate, state },
          replace: true,
        });
      } else {
        // toast.error(
        //   'تعداد درخواست ها بیش از حد مجاز بوده، لطفا دقایقی دیگر دوباره امتحان کنید'
        // );
        const clear = setTimeout(() => {
          navigate.back();
          clearTimeout(clear);
        }, 2000);
      }
    },
  });

  const { mutate: mutateTurnToggle } = useTurntoggleMobileState({
    onSuccess: (data) => {
      const { succeeded, result } = data;
      if (succeeded) {
        // toast.success("Success." + result)
        if (result === 'MobileOtpStateTurnedOff') {
          toast.success(t('Success.MobileStateTurnedOff'));
        }
        if (result === 'MobileOtpStateTurnedOn') {
          toast.success(t('Success.MobileStateTurnedOn'));
        }
        const token = client_id;
        if (token) {
          const clear = setTimeout(() => {
            pushExternal(callBackUrl, token);
            clearTimeout(clear);
          }, 2000);
        }
      } else {
        refetchCaptchaMethod();
      }
    },
    onError: () => {
      refetchCaptchaMethod();
    },
  });

  const SendCodeAgain = () => {
    refechMobileRequest();
  };

  //*handle captch
  const { data: captcha, refetch: refetchCaptcha } = useGetCaptch();

  const refetchCaptchaMethod = () => {
    refetchCaptcha();
    resetField('captchaValue');
  };

  useLayoutEffect(() => {
    if (!client_id) {
      toast.error('توکن شما منقضی شده است.');
      navigate.pushLogin();
    }
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="text-center">
        <h1 className="text-5xl pt-4">
          {state
            ? t(`FormSide.DisableTwoFactorState`)
            : t(`FormSide.EnableTwoFactorState`)}
        </h1>
        <p className="text-xl pt-4 text-right pr-4 text-L-gray-250 font-medium">
          <Trans
            i18nKey={`FormSide.Input.OTP.Placeholder`}
            values={{
              n: starredMessage,
            }}
            components={{ tag: <span className="inline-block ltr p-1" /> }}
          />
        </p>
      </div>

      <div className="p-4">
        <InputPin
          sendCodeAgain={SendCodeAgain}
          value={otp}
          onChange={setOtp}
          expireDate={expireDate}
        />
      </div>

      <div className="m-4">
        <Captcha
          register={register}
          errors={errors}
          captcha={captcha}
          onRefresh={refetchCaptchaMethod}
          setValue={setValue}
          getValues={getValues}
        />
      </div>

      <div className="mt-12 p-4 text-center">
        <Button className="bg-L-primary-50 text-white w-full p-2 rounded text-3xl">
          {t(`FormSide.NextStepButton`)}
          <ChevronLeftIcon className="inline mr-4" />
        </Button>

        <Button
          role={'button'}
          onClick={(event) => {
            event.preventDefault();
            pushReturn(callBackUrl)
          }}
          className="text-L-gray-300 w-full p-2 rounded mt-4 text-3xl"
        >
          {t(`FormSide.CancelText`)}
        </Button>
      </div>
    </form>
  );
};

export default FormTwoFactor;
